import React from 'react';
import Header from './Header/Header';


const Home = () => {
    return (
        <div style={{backgroundImage: `url(../../../../../image/blob-haikei.svg)`
        }} >
            <Header></Header>
        </div>
    );
};

export default Home;